var map = {
	"./available-location-opacity.svg": 12,
	"./available-location.svg": 5580,
	"./bike-black.svg": 4578,
	"./bike.svg": 6088,
	"./clock.svg": 7751,
	"./customer.svg": 5838,
	"./polygon-location.svg": 5307,
	"./unavailable-location-opacity.svg": 7579,
	"./unavailable-location.svg": 2021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4389;